<template>
  <div />
</template>

<script>
import { AdvertisingId } from '@capacitor-community/advertising-id'
export default {
  async mounted () {
    if (!(this.$q.platform.is.capacitor && this.$q.platform.is.ios)) {
      return
    }
    await AdvertisingId.requestTracking()
  }
}
</script>
